

import Notification from "./Notification";
const handleAddToCart = async (productId) => {
  try {
    let cartToken = localStorage.getItem("cart_token");

    const res = await fetch(
      "https://ecom.brightcodeapp.com/wp-json/wc/store/cart/add-item",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(cartToken && { "Cart-Token": cartToken }),
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
        }),
      }
    );

    const newCartToken = res.headers.get("Cart-Token");
    if (newCartToken) {
      localStorage.setItem("cart_token", newCartToken);
    }

    const data = await res.json();

    if (res.ok) {

      Notification.success(
        "Added to Cart",
        "Product added successfully"
      );

      window.dispatchEvent(new Event("cartUpdated"));

    } else {

      Notification.error(
        "Failed",
        "Unable to add product"
      );

    }

  } catch (error) {
    console.error(error);
  }
};

export default handleAddToCart;
